import React, { useContext } from 'react'

import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { CtrContext } from './CtrContext'
import { usePageTitle } from '../app/PageTitleContext'

export default function CtrRawData() {
  const { t } = useTranslation()
  usePageView({ page_detail: 'DMConsole:CTRRawData' })
  usePageTitle(t('pageTitle.ctr.rawData'))
  const ctrContext = useContext(CtrContext)
  const currentCtr = ctrContext.currentCtr

  return currentCtr && <pre id="CTR Raw Data">{JSON.stringify(currentCtr, null, 4)}</pre>
}
